import { render, staticRenderFns } from "./order-popup.vue?vue&type=template&id=03efb9da&scoped=true"
import script from "./order-popup.vue?vue&type=script&lang=js"
export * from "./order-popup.vue?vue&type=script&lang=js"
import style0 from "./order-popup.vue?vue&type=style&index=0&id=03efb9da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03efb9da",
  null
  
)

export default component.exports